import { action, payload } from "ts-action";
import { Course } from "../../@types/course.interface";
import {CourseInsert} from "../../@types/course.interface";
export interface IFetchCoursesPayload {
    name: "COURSE";
}

export interface ICreateCoursePayload {
    name: 'CREATE_COURSE';
    data: {
        course_name: string
    };
}

export const COURSE = "COURSE";


export const fetchCourses = action(COURSE, payload<{ courses: Course[] }>());

export type CourseActionType = ReturnType<typeof fetchCourses>;
